"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flattenAndConcatenateKeysWithNamespace = void 0;
/**
 * Flattens and concatenates translation keys with namespaces to create a flat Translations object for intl provider uses.
 * @example
 * const translationsWithNamespaces = {
 *   common: {
 *     greeting: 'Hello',
 *     farewell: 'Goodbye',
 *   },
 *   dashboard: {
 *     title: 'Dashboard',
 *     subtitle: 'Welcome to the dashboard!',
 *   },
 * };
 *
 * // Call the function to flatten and concatenate keys.
 * const flattenedTranslations = flattenAndConcatenateKeysWithNamespace(translationsWithNamespaces);
 * // The resulting flattenedTranslations object will contain:
 * // {
 * //   'common:greeting': 'Hello',
 * //   'common:farewell': 'Goodbye',
 * //   'dashboard:title': 'Dashboard',
 * //   'dashboard:subtitle': 'Welcome to the dashboard!',
 * // }
 *
 * @typeParam T Type of the translations with namespaces object.
 * @param translationsWithNamespaces The translations object with namespaces.
 * @returns Flattened and concatenated translation keys with values.
 */
const flattenAndConcatenateKeysWithNamespace = translationsWithNamespaces => Object.keys(translationsWithNamespaces).reduce((output, namespace) => {
  const result = {
    ...output
  };
  const namespaceData = translationsWithNamespaces[namespace];
  if (namespaceData) {
    Object.keys(namespaceData).forEach(key => {
      const value = namespaceData[key];
      if (value != null && value !== '') {
        const concatenatedKey = `${namespace}:${key}`;
        result[concatenatedKey] = value;
      }
    });
  }
  return result;
}, {});
exports.flattenAndConcatenateKeysWithNamespace = flattenAndConcatenateKeysWithNamespace;
//# sourceMappingURL=flattenAndConcatenateKeysWithNamespace.js.map